import { QuestionCircleOutlined } from '@ant-design/icons'
import Api from '@api/xiu_yan/shopDataApi'
import Panel from '@common/Panel'
import {
  DATA_MARKETING_PATH_A,
  SHOP_DATA_PATH_A,
  SHOP_PRODUCTS_PATH_A
} from '@constant'
import { getObjValue } from '@hlj/hlj-utils'
import { isUltimate } from '@merchant-backend/util'
import { isTelSaleCityMerchant, plusMinus } from '@util'
import { Tooltip } from 'hljd'
import React, { Component } from 'react'
import auth, { YESTERDAY_DATA } from '../auth'
import styles from './style.module.less'

/** 昨日数据 */
@auth(YESTERDAY_DATA)
export default class extends Component {
  constructor(props) {
    super(props)
    this.getOverview()
    this.state = {
      overview: {}
    }
  }

  // 获取统计
  getOverview = async () => {
    let { data, success } = await Api.overview({ days: 1 })
    let overview = {}
    if (success) {
      overview = data || {}
    }
    this.setState({ overview })
  }

  render() {
    const { overview } = this.state

    const isTelMerchant = isTelSaleCityMerchant()
    const title = '商家服务（付费）'

    const showMask = !isUltimate()

    return (
      <>
        <Panel
          title="昨日数据"
          action={
            <a href={showMask ? DATA_MARKETING_PATH_A : SHOP_DATA_PATH_A}>
              查看更多
            </a>
          }
          style={{ padding: 0 }}
        >
          {showMask ? (
            <div className={styles.mask}>
              <div className={styles.maskTitle}>
                开通{title}，即可查看店铺数据
              </div>
              <a href={SHOP_PRODUCTS_PATH_A}>了解{title}</a>
            </div>
          ) : (
            <div className={styles.box}>
              <div className={styles.label}>
                <p>
                  日环比<Tooltip
                    placement="top"
                    title={'指昨日相比之前一日的数值作比较，发生变化的百分比'}
                  >
                    <QuestionCircleOutlined />
                  </Tooltip>
                </p>

                {!isTelMerchant && (
                  <p>
                    行业排名<Tooltip
                      placement="top"
                      title={
                        '在一定时间范围内的某个上述指标，在同城市同品类商家中的排名。注意：除了跳失率，其他指标越大越好'
                      }
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </p>
                )}
              </div>

              <div className={styles.data}>
                <ul>
                  <li>
                    曝光量<Tooltip
                      placement="top"
                      title={'在时间范围内，当前店铺总曝光次数'}
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </li>
                  <li>
                    访问量<Tooltip
                      placement="top"
                      title={'在时间范围内，当前店铺总访问(点击)次数'}
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </li>
                  <li>
                    CTR<Tooltip
                      placement="top"
                      title={
                        '在时间范围内，当前店铺总访问(点击)次数 / 总曝光次数'
                      }
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </li>
                  <li>
                    平均停留时长(s)<Tooltip
                      placement="top"
                      title={'在时间范围内，在店铺内平均停留时长'}
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </li>
                  <li>
                    跳失率<Tooltip
                      placement="top"
                      title={'在时间范围内，进店停留少于1s即离开的比例'}
                    >
                      <QuestionCircleOutlined />
                    </Tooltip>
                  </li>
                </ul>

                <ul className={styles.num}>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'expo_num.data') || 0}
                    </a>
                  </li>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'visit_num.data') || 0}
                    </a>
                  </li>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'ctr.data') || 0}
                    </a>
                  </li>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'duration.data') || 0}
                    </a>
                  </li>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'jumpout_rate.data') || 0}
                    </a>
                  </li>
                </ul>

                <ul className={styles.compare}>
                  <li>
                    <a
                      style={{
                        color: plusMinus(
                          getObjValue(overview, 'expo_num.compare')
                        )
                      }}
                      href={SHOP_DATA_PATH_A}
                    >
                      {getObjValue(overview, 'expo_num.compare') || 0}
                    </a>
                  </li>
                  <li>
                    <a
                      style={{
                        color: plusMinus(
                          getObjValue(overview, 'visit_num.compare')
                        )
                      }}
                      href={SHOP_DATA_PATH_A}
                    >
                      {getObjValue(overview, 'visit_num.compare') || 0}
                    </a>
                  </li>
                  <li>
                    <a
                      style={{
                        color: plusMinus(getObjValue(overview, 'ctr.compare'))
                      }}
                      href={SHOP_DATA_PATH_A}
                    >
                      {getObjValue(overview, 'ctr.compare') || 0}
                    </a>
                  </li>
                  <li>
                    <a
                      style={{
                        color: plusMinus(
                          getObjValue(overview, 'duration.compare')
                        )
                      }}
                      href={SHOP_DATA_PATH_A}
                    >
                      {getObjValue(overview, 'duration.compare') || 0}
                    </a>
                  </li>
                  <li>
                    <a
                      style={{
                        color: plusMinus(
                          getObjValue(overview, 'jumpout_rate.compare')
                        )
                      }}
                      href={SHOP_DATA_PATH_A}
                    >
                      {getObjValue(overview, 'jumpout_rate.compare') || '-'}
                    </a>
                  </li>
                </ul>
                <ul className={styles.ranking}>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'expo_num.ranking') || '-'}
                    </a>
                  </li>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'visit_num.ranking') || '-'}
                    </a>
                  </li>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'ctr.ranking') || '-'}
                    </a>
                  </li>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'duration.ranking') || '-'}
                    </a>
                  </li>
                  <li>
                    <a href={SHOP_DATA_PATH_A}>
                      {getObjValue(overview, 'jumpout_rate.ranking') || '-'}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}
        </Panel>
      </>
    )
  }
}
